import { Info } from "lucide-react";

const SafetyDisclaimer = ({ children, testId = "safety-disclaimer" }) => {
    return (
        <div
            data-testid={testId}
            className="rounded-2xl border border-brand-navy/10 bg-white px-5 py-5 sm:px-6 sm:py-6"
        >
            <div className="flex items-start gap-3">
                <Info size={18} strokeWidth={1.75} className="mt-0.5 text-brand-navy/65 shrink-0" />
                <p className="text-[15px] text-[#334155] leading-relaxed">
                    {children ??
                        "TopParent is not a therapy service, medical tool, diagnostic tool, or replacement for professional guidance. It suggests parent-led activity ideas that families can adapt to their child\u2019s comfort, ability, and safety."}
                </p>
            </div>
        </div>
    );
};

export default SafetyDisclaimer;
